import { HttpStatusCode } from "axios";
import { alertConstants } from "../../helper/sweet-alert";
import aiConfigurationService from "../../apiServices/ai/aiConfigurationService";
import {
  setApiConfiguration,
  setApiConfigurations,
  setAiAgentKey,
  setAiAgentKeyLoading,
} from "../../store/slices/ai/aiConfigurationSlice";
import { setAIPreviousMessages } from "../../store/slices/common/chatBotSlice";
import { IAgentChatTurn, ISessionDetail } from "../../models/common/IChatBot";


export function createAgentApiKeyConfiguration(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await aiConfigurationService.createApiKeyConfiguration(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        const name = data.get("name");
        callback(alertConstants.conflict, name);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function getApiKeyConfiguration(id: number) {
  return async function (dispatch: any) {
    let response = await aiConfigurationService.getApiKeyConfiguration(id);
    if (response?.success === true) {
      dispatch(setApiConfiguration(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getAllApiConfiguration(collegeId?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await aiConfigurationService.getApiConfigurations(collegeId);
    if (response?.success === true) {
      dispatch(setApiConfigurations(response.data));
    } else {
      console.log("error");
    }
  };
}

export function updateApiKeyConfiguration(
  data: any,
  id: number,
  callback: Function
) {
  return async function () {
    let response = await aiConfigurationService.updateApiKeyConfiguration(
      data,
      id
    );
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function deleteApiKeyConfiguration(id: number, callback: Function) {
  return async function () {
    let response = await aiConfigurationService.deleteApiKeyConfiguration(id);
    if (response === true) {
      callback(alertConstants.deleteSuccess);
    } else {
      callback(alertConstants.deleteFailure);
    }
  };
}

export function getPreviousChatMessage(limit: number) {
  return async function (dispatch: any) {
    let response = await aiConfigurationService.getAIPreviousChatMessages(limit);
    if (response?.success) {
      dispatch(setAIPreviousMessages(response.data));
    } else {
      console.log("error");
    }
  };
}

export function updateAISessions() {
  return async function () {
    await aiConfigurationService.updateAISessions();
  };
}

export function loadChatSessionMessages(sessionId: number) {
  return async function (): Promise<ISessionDetail> {
    const response = await aiConfigurationService.getSessionMessages(sessionId);
    if (Array.isArray(response?.data)) {
      return { messages: response.data, status: "Success", generationId: null };
    }
    return response?.data ?? { messages: [], status: "Success", generationId: null };
  };
}

export function getAiAgentKey() {
  return async function (dispatch: any) {
    dispatch(setAiAgentKeyLoading(true));
    try {
      const response = await aiConfigurationService.getAiAgentKey();
      if (response?.success) {
        dispatch(setAiAgentKey(response.data));
      }
    } finally {
      dispatch(setAiAgentKeyLoading(false));
    }
  };
}
